import { render } from "./Card.vue?vue&type=template&id=4ed7c430&scoped=true&bindings={\"data\":\"props\",\"showPoint\":\"props\",\"showStory\":\"props\",\"toggleSelectCard\":\"setup\",\"showSkinCard\":\"setup\",\"hasSkin\":\"options\",\"img\":\"options\",\"point\":\"options\",\"info\":\"options\",\"handleClick\":\"options\"}"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=4ed7c430&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ed7c430"

export default script